import React, { useState, Fragment } from "react";
import { Tabs, TabList, TabPanel, Tab } from "react-tabs";
import { useDispatch, useSelector } from "react-redux";
import { User } from "react-feather";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import {
  Lost_Password_Check,
  Lost_Password_Update,
} from "../../actions/Auth_action";
const LostPasswordTabset = () => {
  const [phone, setphone] = useState(0);
  const [password, setpassword] = useState("");
  const dispatch = useDispatch();
  const password_obj_check = useSelector(
    (state) => state.AuthReducer.password_obj_check
  );
  const status_check = useSelector((state) => state.AuthReducer.status_check);

  const Lost_Password_Check_Admin = (e) => {
    e.preventDefault();

    if (phone === 0) {
      toast.error("Please Check Inputs");
    } else {
      const user = {
        phone,
      };
      dispatch(Lost_Password_Check(phone, user));
      setphone(0);
    }
  };

  const Lost_Password_Update_Admin = (e) => {
    e.preventDefault();

    if (password === 0) {
      toast.error("Please Check Inputs");
    } else {
      const user = {
        password,
      };
      dispatch(Lost_Password_Update(password_obj_check.phone, user));
      setpassword("");
    }
  };
  return (
    <Fragment>
      <Tabs>
        <TabList className="nav nav-tabs tab-coupon">
          <Tab className="nav-link fk">
            <User />
            لەبیرچوونەوەی وشەی نهێنی
          </Tab>
        </TabList>

        <TabPanel>
          <form className="form-horizontal">
            {status_check === true ? (
              <div className="form-group">
                <input
                  required
                  name="password"
                  type="text"
                  className="form-control fk"
                  placeholder="وشەی نهێنی"
                  value={password}
                  onChange={(e) => setpassword(e.target.value)}
                  autoComplete="off"
                  autoFocus
                />
              </div>
            ) : (
              <div className="form-group">
                <input
                  required
                  name="phone"
                  type="number"
                  className="form-control fk"
                  placeholder="ژمارەی مۆبایل"
                  value={phone === 0 ? "" : phone}
                  onChange={(e) => setphone(e.target.value)}
                  autoComplete="off"
                  autoFocus
                />
              </div>
            )}
            {status_check === true ? (
              <div
                className="btn-toolbar"
                role="toolbar"
                aria-label="Toolbar with button groups"
              >
                <div
                  className="btn-group "
                  role="group"
                  aria-label="First group"
                >
                  <button
                    className="btn btn-primary fk"
                    type="button"
                    onClick={Lost_Password_Update_Admin}
                  >
                    نوێکردنەوە
                  </button>
                </div>
                &nbsp;&nbsp;
                <div
                  className="btn-group "
                  role="group"
                  aria-label="First group"
                >
                  <button className="btn btn-primary" type="button">
                    <Link to="/">
                      <span className="fk" style={{ color: "white" }}>
                        گەڕانەوە
                      </span>
                    </Link>
                  </button>
                </div>
              </div>
            ) : (
              <div
                className="btn-toolbar"
                role="toolbar"
                aria-label="Toolbar with button groups"
              >
                <div
                  className="btn-group "
                  role="group"
                  aria-label="First group"
                >
                  <button
                    className="btn btn-primary fk"
                    type="button"
                    onClick={Lost_Password_Check_Admin}
                  >
                    بەراورد
                  </button>
                </div>
                &nbsp;&nbsp;
                <div
                  className="btn-group "
                  role="group"
                  aria-label="First group"
                >
                  <button className="btn btn-primary" type="button">
                    <Link to="/">
                      <span className="fk" style={{ color: "white" }}>
                        گەڕانەوە
                      </span>
                    </Link>
                  </button>
                </div>
              </div>
            )}
          </form>
        </TabPanel>
      </Tabs>
    </Fragment>
  );
};

export default LostPasswordTabset;
